
import $ from "jquery";

jQuery(document).ready(function () {
    var sidebarList = jQuery(".sidebar__list");
    var sidebarContainer = jQuery(".insight_post_hero__sidebar");

    // If either element doesn’t exist, exit early
    if (!sidebarList.length || !sidebarContainer.length) return;

    // Variables for measurements
    var containerOffsetTop, containerHeight, sidebarHeight;
    var outerWidth, outerHeight, startFix, maxScroll;

    /**
     * Recalculate measurements any time the width changes
     * or when we first enable the “sticky” behavior.
     */
    function recalcMeasurements() {
        containerOffsetTop = sidebarContainer.offset().top;
        containerHeight = sidebarContainer.outerHeight();
        sidebarHeight = sidebarList.outerHeight();
        outerWidth = jQuery(".sidebar__info").outerWidth();
        outerHeight = jQuery(".sidebar__info").outerHeight();

        // 1. Scroll threshold to start fixing
        startFix = containerOffsetTop - 105;
        // 2. Maximum scroll position before pinning at bottom
        maxScroll = containerOffsetTop + containerHeight - (sidebarHeight + 210);
    }

    /**
     * The scroll handler for when width >= 1000px.
     */
    function onScrollSticky() {
        var scrollY = jQuery(window).scrollTop();

        // Before reaching the container
        if (scrollY < startFix) {
            sidebarList.css({
                position: "static",
                top: "auto",
                width: "auto"
            });
            return;
        }

        // If scrolled past the maxScroll point, pin at bottom
        if (scrollY >= (maxScroll - outerHeight)) {
            sidebarList.css({
                position: "absolute",
                // This positions the sidebar inside its container
                top: (containerHeight - sidebarHeight - 105) + "px",
                width: outerWidth
            });
        } else {
            // Otherwise, fix it 105px from top
            sidebarList.css({
                position: "fixed",
                top: (105 + outerHeight) + "px",
                width: outerWidth
            });
        }
    }

    /**
     * Checks the current window width. If >= 1000px, attach the scroll logic;
     * if < 1000px, remove it and reset styles.
     */
    function handleSidebar() {
        var currentWidth = jQuery(window).width();

        if (currentWidth < 1000) {
            // Remove scroll event (if any), reset styles
            jQuery(window).off("scroll.sidebarFix", onScrollSticky);
            sidebarList.css({
                position: "",
                top: "",
                width: ""
            });
        } else {
            // Recalc positions/sizes
            recalcMeasurements();
            // Bind our scroll event using a namespaced event (for easy unbinding)
            jQuery(window).off("scroll.sidebarFix", onScrollSticky);
            jQuery(window).on("scroll.sidebarFix", onScrollSticky);
            // Call it once immediately so the sidebar is set correctly on load
            onScrollSticky();
        }
    }

    // Initialize on document ready
    handleSidebar();

    // Also listen for resize and re-check
    jQuery(window).on("resize", function () {
        handleSidebar();
    });
});
